import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { TopMenuBar } from "../../components/TopMenuBar/TopMenuBar";
import workerImg from "../../assets/worker.png";
// Material-UI Icons for the cards & filter UI
import PersonOutlineIcon from '@mui/icons-material/PersonOutlineOutlined';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import FilterListIcon from "@mui/icons-material/FilterList";
import Button from "@mui/material/Button";
import { api } from "../../TokenManager";
import "./style.css";
import "@fontsource-variable/open-sans";

export const HistoryPage = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [activeTab, setActiveTab] = useState("history"); // 'history', 'kits', 'pallet'
  const [historyData, setHistoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const lastLoadOut = localStorage.getItem("lastLoadOut");
    if (lastLoadOut === "0" || lastLoadOut === 0) {
      setIsDisabled(true);
    }

    const userObject = localStorage.getItem("currentSession");

    console.log("userobject: " + userObject);

    // Mock API fetch call
    /*const fetchHistoryLogs = async () => {
      try {
        setLoading(true);
        // Replace this mock data with your actual fetch/axios call
        const responseData = [
          {
            id: "PKT-20240714-0003-MSKIT",
            updatedBy: "surname.name",
            time: "7:45 pm",
            date: "05/12/2024",
          },
          {
            id: "PKT-20240710-0009",
            updatedBy: "surname.name",
            time: "5:15 pm",
            date: "05/12/2024",
          },
          {
            id: "PKT-20240713-0003ATL",
            updatedBy: "surname.name",
            time: "4:45 pm",
            date: "05/12/2024",
          },
          {
            id: "PKT-20240710-0010",
            updatedBy: "surname.name",
            time: "3:05 pm",
            date: "05/12/2024",
          },
          {
            id: "PKT-20240713-0003",
            updatedBy: "surname.name",
            time: "2:25 pm",
            date: "05/12/2024",
          },
          {
            id: "PKT-20240711-0008",
            updatedBy: "surname.name",
            time: "1:25 pm",
            date: "05/12/2024",
          },
        ];

        setHistoryData(responseData);
      } catch (error) {
        console.error("Error fetching history data:", error);
      } finally {
        setLoading(false);
      }
    };*/

    const fetchHistoryLogs = async () => {
      try {
        setLoading(true);
        const response = await api.get(`/api/user_sessions`);

        // Safely extract items array (defaults to empty array if missing)
        const rawItems = response.data?.items || [];

        // Map payload fields to card fields
        const formattedData = rawItems.map((item) => {
          const createdDate = new Date(item.createdAt);

          // Formats time like "5:52 pm"
          const formattedTime = createdDate.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          });

          // Formats date like "07/29/2026"
          const formattedDate = createdDate.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          });

          return {
            id: item.runId, // Unique React key
            title: item.name, // Display Name (e.g. "pack", "Packout")
            updatedBy: item.display_name || "Unknown",
            time: formattedTime,
            date: formattedDate,
            status: item.status,
          };
        });

        setHistoryData(formattedData);
      } catch (error) {
        console.error("Error fetching history data:", error);
        setHistoryData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchHistoryLogs();
  }, []);

  return (
    <div className="menu-landing">
      <div className="overlap-group">
        <TopMenuBar />

        <div className="undermenu">
          {/* Main Glassmorphism Container on the Right */}
          <div className="left-panel">
            <div className="left-panel-content">
              <h2 className="left-title">What do you need?</h2>
              <p className="left-subtitle">
                Start a new shipment or view previous ones.
              </p>

              <div className="left-panel-buttons">
                <Button
                  href="#/newPack"
                  variant="contained"
                  className="action-btn primary-btn"
                  disableElevation
                >
                  New Packout
                </Button>
                <Button
                  variant="outlined"
                  className="action-btn secondary-btn"
                  disabled={isDisabled}
                >
                  Previous Packout
                </Button>
              </div>
            </div>

            <div className="worker-image-wrapper">
              <img
                src={workerImg}
                alt="Worker illustration"
                className="worker-image"
              />
            </div>
          </div>
          <div className="glass-panel">
            {/* Tabs Header */}
            <div className="tabs-header">
              <button
                className={`tab-btn ${activeTab === "history" ? "active" : ""}`}
                onClick={() => setActiveTab("history")}
              >
                HISTORY LOG CHANGE
              </button>
              <button
                className={`tab-btn ${activeTab === "kits" ? "active" : ""}`}
                onClick={() => setActiveTab("kits")}
              >
                PRE-TAILORED KITS
              </button>
              <button
                className={`tab-btn ${activeTab === "pallet" ? "active" : ""}`}
                onClick={() => setActiveTab("pallet")}
              >
                PALLET INVENTORY
              </button>
            </div>

            {/* Tab 1: History Log Content */}
            {activeTab === "history" && (
              <div className="tab-content">
                <div className="content-subheader">
                  <span>
                    Keep track of change logs and access previous versions of
                    packouts:
                  </span>
                  <button className="filter-btn" aria-label="Filter logs">
                    <FilterListIcon fontSize="small" />
                  </button>
                </div>

                <div className="cards-scroll-container">
                  {loading ? (
                    <div className="empty-message">Loading history logs...</div>
                  ) : historyData.length > 0 ? (
                    historyData.map((item) => (
                      <div className="history-card" key={item.id}>
                        <div className="card-info">
                          {/* Card Title set to 'name' from API */}
                          <h4 className="card-title">{item.title}</h4>

                          <div className="card-meta">
                            <span className="meta-label">Last Update</span>
                            <span className="meta-item">
                              <PersonOutlineIcon className="meta-icon" />
                              {item.updatedBy}
                            </span>
                            <span className="meta-item">
                              <AccessTimeIcon className="meta-icon" />
                              {item.time}
                            </span>
                            <span className="meta-item">
                              <CalendarTodayIcon className="meta-icon" />
                              {item.date}
                            </span>
                          </div>
                        </div>

                        <button
                          className="card-action-btn"
                          onClick={() => {
                            // 1. Fallback to item.id if item.runId is missing
                            const idToSave = item.runId || item.id;

                            if (!idToSave) {
                              console.error("No runId found on item:", item);
                              return;
                            }
                            localStorage.setItem("runId", idToSave);

                            if (item.status === "completed") {
                              navigate("/containerOverviewPage");
                            } else {
                              navigate("/checklistPage");
                            }
                          }}
                        >
                          <OpenInNewIcon />
                        </button>
                      </div>
                    ))
                  ) : (
                    <div className="empty-message">
                      No history records found.
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Tab 2: Pre-Tailored Kits (Placeholder) */}
            {activeTab === "kits" && (
              <div className="tab-content empty-tab">
                <p>Pre-Tailored Kits content will be displayed here.</p>
              </div>
            )}

            {/* Tab 3: Pallet Inventory (Placeholder) */}
            {activeTab === "pallet" && (
              <div className="tab-content empty-tab">
                <p>Pallet Inventory content will be displayed here.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HistoryPage;
